'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Route } from 'react-router-dom';
import historyAdapter from 'react-rhumb/historyAdapterV4';
import { RhumbProvider } from 'react-rhumb';
import Application from './containers/Application';
import rhumbConfig from '../rhumb-config.yaml';
export default /*#__PURE__*/_jsx(Route, {
  path: "/:contentSlug/:pageId/",
  children: props => /*#__PURE__*/_jsx(RhumbProvider, {
    config: rhumbConfig,
    history: historyAdapter(props.history),
    children: /*#__PURE__*/_jsx(Application, Object.assign({}, props))
  })
});